import {Component, OnInit} from '@angular/core';
import {FlexLayoutModule} from '@ngbracket/ngx-layout';
import {Router, RouterLink} from '@angular/router';
import {VersionControllerService} from "../service/version.controller.service";
import {DatePipe, NgIf} from "@angular/common";

@Component({
  selector: 'app-footer',
  imports: [
    FlexLayoutModule,
    NgIf,
    DatePipe,
    RouterLink
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent implements OnInit {

  version = "";
  currentDate = new Date();
  constructor(private router: Router, private versionService: VersionControllerService) {

  }

  ngOnInit() {
    this.versionService.getVersion().subscribe({
      next: resp => {
        this.version = resp;
      }
    });
  }
}
